import { render, staticRenderFns } from "./ProjectDeliverable.vue?vue&type=template&id=3a2ba092&scoped=true"
import script from "./ProjectDeliverable.vue?vue&type=script&lang=js"
export * from "./ProjectDeliverable.vue?vue&type=script&lang=js"
import style0 from "./ProjectDeliverable.vue?vue&type=style&index=0&id=3a2ba092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2ba092",
  null
  
)

export default component.exports